<h3 *ngIf="this.editFlag">Edit: {{ teamHistory.teamName }}</h3>
<h3 *ngIf="!this.editFlag">Add Historical Team</h3>
<form [formGroup]="historicalTeamForm">
  <div fxLayout="column">
    <div fxLayoutAlign="space-between">
      <mat-form-field appearance="outline" floatLabel="always" fxFlex="100%">
        <mat-label>Team Name</mat-label>
        <input matInput forbidAngleBrackets type="text" formControlName="teamName" />
        <mat-error *ngIf="historicalTeamForm.get('teamName').hasError('required')"> Team Name is required </mat-error>
      </mat-form-field>
    </div>
    <div fxLayoutAlign="space-between">
      <mat-form-field appearance="outline" floatLabel="always" fxFlex="100%">
        <mat-label>Position Title</mat-label>
        <input matInput forbidAngleBrackets type="text" formControlName="positionTitle" placeholder="Position Title" />
        <mat-error *ngIf="historicalTeamForm.get('positionTitle').hasError('required')">
          Position Title is required
        </mat-error>
      </mat-form-field>
    </div>
    <div fxLayoutAlign="space-between" formGroupName="dateGroup">
      <mat-form-field appearance="outline" floatLabel="always" fxFlex="47%">
        <mat-label>Start Date</mat-label>
        <input matInput [matDatepicker]="startPicker" formControlName="startDate" [errorStateMatcher]="matcher" />
        <mat-datepicker-toggle matSuffix [for]="startPicker"> </mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
        <mat-error *ngIf="dateFormGroup.hasError('startDateBeforeEndDate')">
          Start date must be before the end date
        </mat-error>
        <mat-error *ngIf="dateFormGroup.hasError('nullStartDate')"> Start date is required </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" floatLabel="always" fxFlex="47%">
        <mat-label>End Date</mat-label>
        <input
          matInput
          [matDatepicker]="endPicker"
          formControlName="endDate"
          placeholder="End Date"
          [errorStateMatcher]="matcher"
        />
        <mat-datepicker-toggle matSuffix [for]="endPicker"> </mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
        <mat-error *ngIf="dateFormGroup.hasError('nullEndDate')"> End date is required </mat-error>
      </mat-form-field>
    </div>
    <mat-dialog-actions>
      <div>
        <button
          *ngIf="this.editFlag"
          mat-button
          color="primary"
          [disabled]="!historicalTeamForm.valid"
          (click)="manageHistoricalTeam()"
        >
          UPDATE
        </button>
        <button
          *ngIf="!this.editFlag"
          mat-button
          color="primary"
          [disabled]="!historicalTeamForm.valid"
          (click)="manageHistoricalTeam()"
        >
          ADD
        </button>
      </div>
      <div>
        <button type="button" mat-button (click)="dialogRef.close()">CANCEL</button>
      </div>
    </mat-dialog-actions>
  </div>
</form>
